import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../Store";
import CallButtonModel from "../../CallButtonModel";
import ETAcomponent from "./ETAcomponent";

const InfoContainerHedin = () => {
  const { casesStore } = useStore();
  const { t } = useTranslation();
  const event = casesStore.latestEvent;
  if (!event) return <div id="info-container-hedin" />;

  return (
    <div id="info-container-hedin">
      <article className="container-hedin">
        <div className="container bk-color-product">
          <div className="padding--10">
            <div className="logo-viking-hedin margin--top-10" />
            <div>
              <p>{t("EstimatedArrival")}</p>
              <div className="time-container">
                <p>{t("ETA")}<ETAcomponent /></p>
              </div>
            </div>
            <hr />
            <p>{t("CurrentStatus")}:</p>
            <p className="bold-text">{t(`statuscontainerevent${event.eventType}`)}</p>
          </div>
        </div>
        <div className="container margin--top-30 margin--bottom-30">
          <CallButtonModel />
        </div>
      </article>
    </div>
  );
};

export default observer(InfoContainerHedin);
